var map = {
	"./agents/agents.module": [
		"./src/app/agents/agents.module.ts",
		"common",
		"agents-agents-module"
	],
	"./approvals/approval.module": [
		"./src/app/approvals/approval.module.ts",
		"common",
		"approvals-approval-module"
	],
	"./authentication/authentication.module": [
		"./src/app/authentication/authentication.module.ts"
	],
	"./candidates-approvals/candidates-approval.module": [
		"./src/app/candidates-approvals/candidates-approval.module.ts",
		"common",
		"candidates-approvals-candidates-approval-module"
	],
	"./churn/churn.module": [
		"./src/app/churn/churn.module.ts",
		"churn-churn-module"
	],
	"./customers/customers.module": [
		"./src/app/customers/customers.module.ts",
		"common",
		"customers-customers-module"
	],
	"./dashboards/dashboard.module": [
		"./src/app/dashboards/dashboard.module.ts",
		"dashboards-dashboard-module"
	],
	"./devices/devices.module": [
		"./src/app/devices/devices.module.ts",
		"devices-devices-module"
	],
	"./dms/dms.module": [
		"./src/app/dms/dms.module.ts",
		"common",
		"dms-dms-module"
	],
	"./election/election.module": [
		"./src/app/election/election.module.ts",
		"election-election-module"
	],
	"./management/management.module": [
		"./src/app/management/management.module.ts",
		"management-management-module"
	],
	"./momokash/momokash.module": [
		"./src/app/momokash/momokash.module.ts",
		"common",
		"momokash-momokash-module"
	],
	"./organizations/organizations.module": [
		"./src/app/organizations/organizations.module.ts",
		"organizations-organizations-module"
	],
	"./report/report.module": [
		"./src/app/report/report.module.ts",
		"report-report-module"
	],
	"./system/system.module": [
		"./src/app/system/system.module.ts",
		"system-system-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;